var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"9.5","cy":"9.5","r":"7.5","key":0}),React.createElement("path",{"d":"M15 15l7 7","key":1})]));
}

SearchInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
